//
//
//
//
//
//
//
//

// import setShareConfig from 'common/wxShare.js'
import uParse from '@/components/gaoyia-parse/parse.vue'
import moment from 'dayjs'
export default {
  data () {
    return {
      routeId: '',
      noUse: true,
      isOpen: false,
			id: '',
      headerDateList: {
        salePrice: '',
        childPrice: '',
        date: ''
      },
      detail: {
        photoImages: '',
        detail: '',
        name: ''
      }
    }
  },
  components: {
    uParse
  },
		onLoad(event) {
			this.id = event.id
			this.init()
		},
  methods: {
    async init () {
      let data = await this.queryDetail()
      data.data.createTime = moment(data.data.createTime).format('YYYY年MM月DD日 HH:mm')
      this.detail = data.data
      // setShareConfig(data.data.name, '', window.location.hash.split('#')[1], this.$getImg(data.data.coverImagesUrl))
      this.loading = false
    },
    queryDetail () {
      return this.$ajax({
        method: 'post',
        url: '/weChat/cms/notice/queryDetail',
        data: {
          id: this.id
        }
      })
    }
  }
}
